import React, { FC, Fragment } from 'react'
import { theme } from '@mtsdengi/ui-kit'
import { SmartText, SmartVisibleChild } from '@mtsdengi/common'
import { TFaq } from '../../types'
import { InnerAccordion } from '../InnerAccordion'

type TFaqMobile = Omit<TFaq, 'onChangeCategory'>

export const FaqMobile: FC<TFaqMobile> = ({ sections, onCollapseQuestion, onExpandQuestion }) => (
  <SmartVisibleChild
    conditions={{
      mob: 'block',
      md: 'none',
    }}
  >
    {sections.map(({ title, questions }, index) => (
      <Fragment key={`${index}_${title}`}>
        <SmartText
          fontFamily={theme.fonts.font_family_comp}
          fontWeightMob={theme.fonts.font_weights.medium}
          fontSizeMob={theme.fonts.font_sizes.header.h4}
          lineHeightMob={theme.fonts.line_heights.header.h4}
          marginBottomMob={theme.spacings.sm}
        >
          {title}
        </SmartText>
        <InnerAccordion items={questions} onExpandQuestion={onExpandQuestion} onCollapseQuestion={onCollapseQuestion} />
      </Fragment>
    ))}
  </SmartVisibleChild>
)
